export default __webpack_public_path__ + "static/media/MEX.42f2205b.svg";